var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDthEntertainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5127 38.9428L15.4847 30.7178L23.7097 38.9428",
    stroke: "#002970",
    strokeWidth: 2.16916,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0681 36.2098L15.3581 39.4999L18.6482 36.2098",
    stroke: "#002970",
    strokeWidth: 2.16916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5303 23.3781L35.3511 17.8103V7.56065L34.2755 6.48507M34.2755 6.48507L32.8502 5.05977C32.4181 4.62763 31.7144 4.63768 31.2948 5.08199L30.6336 5.78204C30.2306 6.20875 30.2402 6.87863 30.6552 7.29365L31.2941 7.93259C31.7177 8.35614 32.4044 8.35614 32.828 7.93259L34.2755 6.48507Z",
    stroke: "#002970",
    strokeWidth: 2.16916,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3511 7.56065L34.2755 6.48507M34.2755 6.48507L32.8502 5.05977C32.4181 4.62763 31.7144 4.63768 31.2948 5.08199L30.6336 5.78204C30.2306 6.20875 30.2402 6.87863 30.6552 7.29365L31.2942 7.93259C31.7177 8.35614 32.4044 8.35614 32.828 7.93259L34.2755 6.48507Z",
    stroke: "#00BAF2",
    strokeWidth: 2.16916,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4846 24.5171L15.4846 38.816",
    stroke: "#002970",
    strokeWidth: 2.16916,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7419 25.4595C28.4298 26.581 22.8925 24.3351 18.245 19.7092C14.1388 15.622 11.8873 10.8314 12.1816 7.48299",
    stroke: "#002970",
    strokeWidth: 2.16916,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7509 12.8259C28.583 15.6449 30.5179 18.7527 31.3889 21.457C32.2791 24.2209 31.9792 26.2444 30.9092 27.3193C29.775 28.4588 27.4803 29.0018 24.5414 28.4291C21.6608 27.8676 18.3984 26.2639 15.617 23.4954C12.8331 20.7244 11.0857 17.3383 10.3911 14.3201C9.67791 11.2208 10.1319 8.84192 11.2337 7.73497C12.3037 6.66004 14.3257 6.35075 17.0938 7.2281C19.8021 8.08651 22.9188 10.007 25.7509 12.8259Z",
    stroke: "#002970",
    strokeWidth: 2.16916,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDthEntertainment);
export default __webpack_public_path__ + "static/media/dthEntertainment.3c473c496aa23930a6bfff80e65101fe.svg";
export { ForwardRef as ReactComponent };